/**
 * ZenMarkup Privacy Analytics — Map Tooltip & Legend.
 *
 * Tooltip creation, show/hide, and gradient legend bar for the world map.
 * Extracted from map.js to keep modules under 200 lines.
 */

import { formatCompact } from './utils.js';

let tooltip = null;

/**
 * Create the tooltip element inside the map container.
 *
 * @param {HTMLElement} container  The map container element.
 */
export function create(container) {
	if (tooltip) {
		return;
	}

	tooltip = document.createElement('div');
	tooltip.className = 'zmpa-map-tooltip';
	container.appendChild(tooltip);
}

/**
 * Show tooltip near the cursor with country name and optional count.
 *
 * @param {MouseEvent}  e
 * @param {string}      name
 * @param {number|null} count
 * @param {HTMLElement}  container
 */
export function show(e, name, count, container) {
	if (!tooltip || !name) {
		return;
	}

	if (count && Number(count) > 0) {
		tooltip.textContent = name + ' \u00b7 ' + formatCompact(count);
	} else {
		tooltip.textContent = name;
	}
	tooltip.classList.add('zmpa-visible');

	const rect = container.getBoundingClientRect();
	const x = e.clientX - rect.left + 12;
	const y = e.clientY - rect.top - 8;

	tooltip.style.left = x + 'px';
	tooltip.style.top = y + 'px';
}

/** Hide the tooltip. */
export function hide() {
	if (tooltip) {
		tooltip.classList.remove('zmpa-visible');
	}
}

/**
 * Build a gradient legend bar showing the data range.
 *
 * @param {HTMLElement} container  The map container element.
 * @param {number}      max       Highest visitor count.
 */
export function buildLegend(container, max) {
	let legend = container.querySelector('.zmpa-map-legend');

	if (!legend) {
		legend = document.createElement('div');
		legend.className = 'zmpa-map-legend';

		const bar = document.createElement('div');
		bar.className = 'zmpa-map-legend-bar';

		const labels = document.createElement('div');
		labels.className = 'zmpa-map-legend-labels';

		legend.appendChild(bar);
		legend.appendChild(labels);
		container.appendChild(legend);
	}

	const labels = legend.querySelector('.zmpa-map-legend-labels');
	const mid = Math.round(max / 2);
	const showMid = mid > 0 && mid < max;
	labels.innerHTML = showMid
		? '<span>0</span><span>' + formatCompact(mid) + '</span><span>' + formatCompact(max) + '</span>'
		: '<span>0</span><span>' + formatCompact(max) + '</span>';
}
